import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from 'design-system';

import MiniTable from './components/MiniTable';

import type { MiniTableType } from '../../types';

type MiniTableContainerProps = {
  tables: MiniTableType[];
};

const MiniTablesContainer = ({ tables }: MiniTableContainerProps) => {
  if (tables.length === 0) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyTitle>No market tables available.</EmptyTitle>
          <EmptyDescription>Tables published for this market will appear here.</EmptyDescription>
        </EmptyHeader>
      </Empty>
    );
  }

  return (
    <ul
      aria-label='Market mini tables'
      className='grid h-full min-h-[250px] max-h-[650px] flex-1 grid-cols-1 content-start gap-3 overflow-y-auto md:grid-cols-2'
    >
      {tables.map(table => (
        <li
          key={table.name}
          className='min-w-0'
        >
          <MiniTable table={table} />
        </li>
      ))}
    </ul>
  );
};

export default MiniTablesContainer;
